export default __webpack_public_path__ + "483d3bf0a7e860bbf67ccdf1dc59dba6.png";